import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styles from './review.module.scss';
import { SheduleInterview } from '../../../../../../services/util/sheduleInterviews';
import { CustomButton } from '../../../../../shared/customButton';


const Review = (props) => {
    let moment = require('moment-timezone');
    const [state, setState] = useState(false);

    const submitDetails = async () => {
        setState(true)
        //time
        let dateTime = moment(props.values.dateTime).format("YYYY-MM-DD HH:mm");
        //timeZone
        let timeZone = await props.values.timeZone.value;
        //reviewers
        let reviwersArray = [];
        await (props.reviewers).forEach(element => {
            reviwersArray.push(element._id)
        });
        let respond = await SheduleInterview(props.values.id, dateTime, timeZone, reviwersArray, props.values.interviewType, props.values.address, props.values.guidelineDescription);
        if (respond.success === true) {
            setState(false)
            props.previousPage(1)
            props.handleClose()
            props.GetTaskValues();
            props.getAllPendingInterviewValues()
        } else {
            setState(false)
        }
    }


    return (
        <div>
            <Col>
                <Row className={styles.sheduleInterviewDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Date&nbsp;and&nbsp;Time&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{moment(props.values.dateTime._d).format("YYYY-MM-DD HH:mm")}</span>
                    </Col>
                </Row>

                <Row className={styles.sheduleInterviewDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Time&nbsp;Zone&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.timeZone.label}</span>
                    </Col>
                </Row>

                <Row className={styles.sheduleInterviewDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Interviewers&nbsp;:</span><br />
                        {
                            (props.reviewers).map((value, index) => {
                                return (
                                    <div>
                                        <span key={index} className={styles.rowValues}><i className="fas fa-circle"></i>&nbsp;{value.user_id.email}&nbsp;-&nbsp;{value.user_id.first_name}&nbsp;{value.user_id.last_name}</span>
                                        <br />
                                    </div>

                                )
                            })
                        }
                    </Col>
                </Row>

                <Row className={styles.sheduleInterviewDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Interview&nbsp;Type&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.interviewType === 0 ? 'Online Interview' : props.values.interviewType === 1 ? 'Physical Interview' : null}</span>
                    </Col>
                </Row>

                {props.values.interviewType === 1 &&
                    <Row className={styles.sheduleInterviewDetailsRow}>
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}>Interview&nbsp;Location&nbsp;Address&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.address}</span>
                        </Col>
                    </Row>
                }

                <Row className={styles.sheduleInterviewDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1">
                        <span className={styles.rowSubTitle}>Interview&nbsp;Guidelines&nbsp;For&nbsp;Candidates&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{props.values.guidelineDescription ? props.values.guidelineDescription : 'No Guidelines'}</span>
                    </Col>
                </Row>

            </Col>
            <div className="mt-5">
                <Row>
                    <Col>
                        <CustomButton
                            buttonType="submit"
                            label="Back"
                            type="defaultBtn"
                            handleClick={() => props.previousPage(1)}
                            disabled={state === true ? true : false}
                        />
                    </Col>
                    <Col>
                        <CustomButton
                            buttonType="submit"
                            label="Submit"
                            type="primaryBtn"
                            backicon={
                                state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    : ''
                            }
                            disabled={state === true ? true : false}
                            handleClick={() => submitDetails()}
                        />
                    </Col>
                </Row>
            </div>

        </div>
    )
}

export default Review;
